/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
const downloadRecepitConfig = validationConfig['downloadCenter']['downloadReceipt']

const validateFromDate = downloadRecepitConfig['isFromDateRequired']
    ? {
        fromDate: Yup.date()
            .max(new Date(), VALIDATION_MESSAGES.FORM_DATE_VALID)
            .required(VALIDATION_MESSAGES.FORM_DATE_REQUIRED),
    }
    : {
        fromDate: Yup.date().optional(),
    }

const validateToDate = downloadRecepitConfig['isToDateRequired']
    ? {
        toDate: Yup.date()
            .min(Yup.ref('fromDate'), VALIDATION_MESSAGES.TO_DATE)
            .max(new Date(), VALIDATION_MESSAGES.TO_DATE_VALID)
            .required(VALIDATION_MESSAGES.TO_DATE_REQUIRED),
    }
    : {
        toDate: Yup.date().optional(),
    }
export const DownloadReceiptSchema = Yup.object().shape({
    ...validateFromDate,
    ...validateToDate
})